import { Uploader } from '@/features/v2/hh/surveys/documents/Uploaders';

const Documents = () => {
  return <Uploader />;
};

export default Documents;
